//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/NXColor.js";
import "../no/DisplayableObject.js";
import "../no/SheetmetalFeatureProperty.js";
import "../no/Expression.js";
let d=[[[1,"BendRadius",0,"Expression",0],[1,"BendReliefDepth",0,"Expression",0],[1,"BendReliefWidth",0,"Expression",0],[0,"BottomFaceColor",1,0],[0,"DeviationalTolerance",1,0],[1,"FlatPatternHoleTreatmentDiameter",0,"Expression",0],[1,"FlatPatternInsideCornerTreatmentValue",0,"Expression",0],[1,"FlatPatternOutsideCornerTreatmentValue",0,"Expression",0],[0,"FlatSolidColor",1,0],[0,"FlatSolidLayer",1,0],[1,"FlexibleCableConductorSpacing",0,"Expression",0],[1,"FlexibleCableConductorWidth",0,"Expression",0],[0,"FlexibleCableContactFace",1,0],[1,"FlexibleCableStrippingLength",0,"Expression",0],[0,"HoleTreatmentType",1,0],[0,"InsideCornerTreatmentType",1,0],[0,"IntegratePhysicalMaterialLibrary",1,0],[0,"MaintainCircularShapeForHoles",1,0],[1,"MaterialThickness",0,"Expression",0],[0,"MinimumArcTolerance",1,0],[1,"NeutralFactor",0,"Expression",0],[0,"OutsideCornerTreatmentType",1,0],[0,"ParameterEntryType",1,0],[0,"RemoveBendReliefs",1,0],[0,"SimplifyBSplines",1,0],[0,"TopFaceColor",1,0]],[[[],"GetMaterialName",{R_:{materialName:''}},0,0],[["materialName"],"SetMaterial",{},1,0],[["numMaterialNames"],"GetMaterialNames",{R_:{materialNames:""}},0,0],[["materialName","numberOfProperties","propertyNames"],"GetMaterialProperties",{R_:{propertyValues:""}},1,0],[["multiHeightLayerScheme"],"SetMultiThicknessLayerScheme",{},1,0],[[],"GetMultiThicknessLayerScheme",{R_:{multiHeightLayerScheme:''}},0,0],[["objectType"],"GetFlatPatternObjectTypeDisplay",{R_:{displayData:''}},1,0],[["objectType","displayData"],"SetFlatPatternObjectTypeDisplay",{},2,0],[["count","displayData"],"GetFlatPatternAllObjectTypeDisplay",{},0,0],[["calloutType"],"GetFlatPatternCalloutTypeDisplay",{R_:{displayData:''}},1,0],[["calloutType","displayData"],"SetFlatPatternCalloutTypeDisplay",{},2,0],[["calloutType","numContents"],"GetFlatPatternCalloutTypeContents",{R_:{contents:""}},1,0],[["calloutType","contents"],"SetFlatPatternCalloutTypeContents",{},2,0],[[],"GetFlatPatternCalloutOrientationType",{R_:{orientation:''}},0,0],[["orientation"],"SetFlatPatternCalloutOrientationType",{},1,0],[["count","displayData"],"GetFlatPatternAllCalloutTypeDisplay",{},0,0],[["curveType"],"GetPlanarSegmentCurveDisplayData",{R_:{displayData:''}},1,0],[["curveType","displayData"],"SetPlanarSegmentCurveDisplayData",{},2,0]],[]];
SPLM.Preferences.FpcdPreferencesBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Preferences.FpcdPreferencesBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Preferences.FpcdPreferencesBuilder.FlatPatternObjectTypeDisplay = class{
    constructor(type,isEnabled,color,layer,font,width){
        this.type=type;this.isEnabled=isEnabled;this.color=color;this.layer=layer;this.font=font;this.width=width;}
    get Type(){return this.type}
    set Type(val){this.type = val}
    get Isenabled(){return this.isEnabled}
    set Isenabled(val){this.isEnabled = val}
    get Color(){return this.color}
    set Color(val){this.color = val}
    get Layer(){return this.layer}
    set Layer(val){this.layer = val}
    get Font(){return this.font}
    set Font(val){this.font = val}
    get Width(){return this.width}
    set Width(val){this.width = val}
};

SPLM.Preferences.FpcdPreferencesBuilder.FlatPatternCalloutTypeDisplay = class{
    constructor(type,isEnabled,name){
        this.type=type;this.isEnabled=isEnabled;this.name=name;}
    get Type(){return this.type}
    set Type(val){this.type = val}
    get Isenabled(){return this.isEnabled}
    set Isenabled(val){this.isEnabled = val}
    get Name(){return this.name}
    set Name(val){this.name = val}
};

SPLM.Preferences.FpcdPreferencesBuilder.PlanarSegmentCurvesDisplayData = class{
    constructor(type,isEnabled,color,font,width){
        this.type=type;this.isEnabled=isEnabled;this.color=color;this.font=font;this.width=width;}
    get Type(){return this.type}
    set Type(val){this.type = val}
    get Isenabled(){return this.isEnabled}
    set Isenabled(val){this.isEnabled = val}
    get Color(){return this.color}
    set Color(val){this.color = val}
    get Font(){return this.font}
    set Font(val){this.font = val}
    get Width(){return this.width}
    set Width(val){this.width = val}
};

SPLM.Preferences.FpcdPreferencesBuilder.ParameterEntryTypes = Object.freeze({
    "Value" : "Value", "MaterialTable" : "MaterialTable"});

SPLM.Preferences.FpcdPreferencesBuilder.FlexibleCableContactFaceOptions = Object.freeze({
    "TopFace" : "TopFace", "BottomFace" : "BottomFace"});

SPLM.Preferences.FpcdPreferencesBuilder.FlatPatternObjectTypes = Object.freeze({
    "BendUpCenterLine" : "BendUpCenterLine", "BendDownCenterLine" : "BendDownCenterLine", "BendTangentLine" : "BendTangentLine", "OuterMoldLine" : "OuterMoldLine", "InnerMoldLine" : "InnerMoldLine", "ExteriorCurves" : "ExteriorCurves", "InteriorCutoutCurves" : "InteriorCutoutCurves", "InteriorFeatureCurves" : "InteriorFeatureCurves", "LighteningHoleCenter" : "LighteningHoleCenter", "JoggleLine" : "JoggleLine", "AddedTopGeometry" : "AddedTopGeometry", "AddedBottomGeometry" : "AddedBottomGeometry", "ToolMarker" : "ToolMarker", "Hole" : "Hole", "CenterMark" : "CenterMark"});

SPLM.Preferences.FpcdPreferencesBuilder.FlatPatternCalloutOrientationTypes = Object.freeze({
    "Leadered" : "Leadered", "Aligned" : "Aligned"});

SPLM.Preferences.FpcdPreferencesBuilder.PlanarSegmentCurveTypes = Object.freeze({
    "BendCenterLine" : "BendCenterLine", "BendTangentLine" : "BendTangentLine"});

export default SPLM;